export enum MediaTypes {
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
}
